export default __webpack_public_path__ + "static/media/autoservicio-destock1.e332d635.jpg";